import React from 'react';
import ManufacturingIntro from '../components/ManufacturingIntro/ManufacturingIntro';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const ManufacturingPage = () => {
  return (
    <>
      <ManufacturingIntro />
      <CtaSection />
    </>
  );
};

export default ManufacturingPage;
